import { combineReducers } from 'redux';
import jobInvocations from './jobInvocations/';

export default combineReducers({
  jobInvocations,
});



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_remote_execution-8.0.0-2.fm3_4.el8.noarch/usr/share/gems/gems/foreman_remote_execution-8.0.0/webpack/react_app/redux/reducers/index.js